import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/incoming-messages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::index
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:97
* @route '/admin/incoming-messages'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
export const show = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/incoming-messages/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
show.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return show.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
show.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
show.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
const showForm = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
showForm.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\IncomingMessagesController::show
* @see app/Http/Controllers/Admin/IncomingMessagesController.php:171
* @route '/admin/incoming-messages/{id}'
*/
showForm.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const incomingMessages = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
}

export default incomingMessages